import { Text } from '@/components/Text';

export type DealFinePrintProps = {
  /** Our requirements for the deal (`deal.terms`). */
  terms?: string | null;
  /** The partner's legal lines (`marketing_copy.compliance_disclosure`). */
  disclosure?: string | null;
  testID?: string;
};

/**
 * The deal's fine print. Some disclosures restate our terms and add the legal
 * lines (Invest, Crypto), so showing both would print the terms twice; others
 * are only the partner's own legal text (Checking's direct-deposit bonus
 * rules), and dropping the terms there would hide what the user actually has
 * to do to get paid. So: the disclosure alone when it already contains the
 * terms, otherwise the terms followed by the disclosure.
 */
export function DealFinePrint({ terms, disclosure, testID }: DealFinePrintProps) {
  const t = terms?.trim();
  const d = disclosure?.trim();
  const paragraphs = d && t && d.includes(t) ? [d] : [t, d].filter((p): p is string => !!p);
  if (!paragraphs.length) return null;
  return (
    <Text variant="caption" color="textMuted" testID={testID}>
      {paragraphs.join('\n\n')}
    </Text>
  );
}
